import { useEffect, useState } from"react";
import { Mail, Trash2, CheckCircle2 } from"lucide-react";
import { api } from"@/lib/api";
import { Header } from '../../components/layout/Header';

export default function ContactsAdmin() {
 const [items, setItems] = useState([]);
 const load = () => api.get("/admin/contacts").then((r) => setItems(r.data));
 useEffect(() => { load(); }, []);

 const markRead = async (id) => { await api.put(`/admin/contacts/${id}/status`, { status: 'lida' }); load(); };
 const del = async (id) => {
 if (!window.confirm("Arquivar mensagem?")) return;
 await api.put(`/admin/contacts/${id}/status`, { status: 'arquivada' }); load();
 };

 return (
 <div data-testid="admin-contacts">
 <Header title="Mensagens" subtitle={`${items.length} mensagens · ${items.filter((m) => !m.read).length} não lidas`} />

 <div className="mt-10 space-y-4">
 {items.map((m) => (
 <div key={m.id} className={`p-6 border ${m.read ?"" :"border-mocha/30"}`} data-testid={`contact-${m.id}`}>
 <div className="flex justify-between items-start gap-4">
 <div>
 <p className="admin-eyebrow">{m.interest ||"Geral"}</p>
 <h3 className="font-serif text-xl text-ink mt-1">{m.subject}</h3>
 <p className="text-xs admin-text-muted mt-2">
 <Mail size={12} className="inline mr-1" /> {m.name} &lt;{m.email}&gt; {m.phone && `· ${m.phone}`}
 </p>
 </div>
 <div className="flex flex-col gap-2 items-end shrink-0">
 <p className="text-xs admin-text-muted">{new Date(m.created_at).toLocaleString("pt-BR")}</p>
 {!m.read && (
 <button onClick={() => markRead(m.id)} className="text-xs admin-text-gold uppercase tracking-widest flex items-center gap-1"><CheckCircle2 size={12}/>Marcar lida</button>
 )}
 <button onClick={() => del(m.id)} className="text-xs text-red-600 uppercase tracking-widest flex items-center gap-1"><Trash2 size={12}/>Excluir</button>
 </div>
 </div>
 <p className="mt-4 text-sm font-medium admin-text-muted leading-relaxed whitespace-pre-line">{m.message}</p>
 </div>
 ))}
 {items.length === 0 && <p className="text-center admin-text-muted py-12">Nenhuma mensagem ainda.</p>}
 </div>
 </div>
 );
}
